var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Dissatisfied(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 64.5A26.5 26.5 0 1164.5 38 26.53 26.53 0 0138 64.5zm0-49A22.5 22.5 0 1060.5 38 22.53 22.53 0 0038 15.5zm-9.84 12.38a4 4 0 100 8 4 4 0 000-8zm19.69 0a4 4 0 101.524.302 4 4 0 00-1.534-.302h.01zm2.64 24.66a2 2 0 00.51-2.78 15.74 15.74 0 00-6.91-5.69 15.62 15.62 0 00-3-.92 15.902 15.902 0 00-6.33 0 15.642 15.642 0 00-3 .92A15.77 15.77 0 0025 49.76a2.001 2.001 0 002.003 3.228A2 2 0 0028.29 52a11.75 11.75 0 015.15-4.25c.71-.298 1.446-.526 2.2-.68a11.932 11.932 0 014.72 0A11.7 11.7 0 0147.71 52a2 2 0 002.78.54z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Dissatisfied.1d8bdc66.svg";
export { SvgK1Dissatisfied as ReactComponent };